import { MenuIconName } from "../pages/Dashboard/MenuIcon";

export type NavigationItem = { label: string; href: string; icon: MenuIconName; external?: boolean; end?: boolean };
export const navigationGroups: { label: string; items: NavigationItem[] }[] = [
    { label: "Работа салона", items: [
        { label: "Главная", href: "/", icon: "home", end: true },
        { label: "Операционный день", href: "/operations-day", icon: "clock" },
        { label: "Записи", href: "/records", icon: "calendar" },
        { label: "Расписание", href: "/schedule", icon: "plans" },
        { label: "Профиль салона", href: "/company-info", icon: "salon" },
    ] },
    { label: "Команда", items: [
        { label: "Мастера", href: "/staff-profiles", icon: "masters" },
        { label: "Планы мастеров", href: "/staff-plans", icon: "plans" },
        { label: "Эффективность команды", href: "/team-performance", icon: "performance" },
    ] },
    { label: "Финансы", items: [
        { label: "Аналитика салона", href: "/salon-analytics", icon: "analytics" },
        { label: "Финансы и платежи", href: "/finance", icon: "finance" },
        { label: "Транзакции", href: "/transactions", icon: "ruble" },
        { label: "Документы", href: "/documents", icon: "folder" },
    ] },
    { label: "Развитие и оборудование", items: [
        { label: "Склад и закупки", href: "/inventory", icon: "inventory" },
        { label: "Промокоды", href: "/promocodes", icon: "ticket" },
        { label: "Мониторы", href: "/monitors-ads", icon: "monitor" },
        { label: "Терминал", href: "/terminal", icon: "terminal", end: true },
        { label: "Маркировка", href: "/terminal/marking", icon: "marking" },
    ] },
    { label: "Связь и помощь", items: [
        { label: "База знаний", href: "/knowledge", icon: "book" },
        { label: "Поддержка", href: "/support", icon: "tools" },
        { label: "Заказы дизайна", href: "/order-layout", icon: "palette" },
        { label: "Чаты", href: "/chats", icon: "chat" },
        { label: "ИИ-помощник", href: "/assistant", icon: "assistant" },
        { label: "Библиотека макетов", href: "https://media.chio-chio.ru/", icon: "folder", external: true },
    ] },
];

export function humanRole(role?: string | null): string {
    const names: Record<string, string> = { ROLE_FR: "Франчайзи", ROLE_FRANCHISEE: "Франчайзи", ROLE_MANAGER: "Менеджер", ROLE_ADMIN: "Администратор", ROLE_USER: "Пользователь", ROLE_CLIENT: "Клиент", ROLE_STAFF: "Сотрудник" };
    return !role ? "Франчайзи" : names[role] || (role.startsWith("ROLE_") ? "Пользователь" : role);
}
